<template>
    <div class="announ">
        <div class="title">工厂类型占比</div>
        <div class="block">
            <div id="mainD"  ref="chart"></div>  
        </div>
    </div>
</template>
<script>
import {url,operate} from '@/utils/config'
import {postFun,getFun,deleteFun} from '@/utils/httpFun'
export default {
  components:{
     
  },
  props:{
    width:{
      type:Number,
      default:100
    }  
  },
  data: ()=>({
     total:0,
     listArray:[],
     myChart:{}
  }),
  computed: {
      refreshStr() {
         return this.$store.state.windowwidth || this.$store.state.windowHeight;
      }
   },
    watch: {
      refreshStr(val) {
         if (val) {
            this.myChart.resize()
         }
      }
   },
  mounted() {

     this.getInfo()
  },
  methods:{
    getInfo(){
        getFun(operate.FCLASSPROPORTION,{},res=>{
           let listArray  = []
           let list = res.data
           let total = 0
           for(var i in list){
            if(list[i].factoryCount>0){
              console.log('====================',list[i])
               total = total + list[i].factoryCount 
               listArray.push({name:list[i].name,value:list[i].factoryCount,factoryCount:list[i].factoryCount}) 
            }

           }
           listArray.forEach(ev=>{
             ev.value = Math.round(ev.value / total * 10000) / 100;
           })  
           this.listArray = listArray
           this.total = total
           this.init() 
        })
    },
    init(){
        let myChart = this.$_echarts.init(document.getElementById('mainD'))
        this.myChart = myChart
        var option = {
          tooltip: {
            show:true,
            trigger:'item',
            formatter:(params,ticket,callback)=>{
              console.log('显示====',params);

              let str = '';

              if(!!!params.data.factoryCount)return '';

              str += `
                ${params.data.name}<br>
                总数:${params.data.factoryCount}
                <br>
                类型占比:${params.data.value}%
              `
              return str;
            }
          },
          series: [
            {
              name: '设备分类占比',
              type: 'pie',
              selectedMode: 'single',
              color:['#FFFFFF'],
              radius: ['23%', '60%'],
              label: {
                position: 'inner',
                fontSize: 14,
                rich:{
                  time:{
                    color:'#20388933'
                  }
                }
              },
              labelLine: {
                show: false
              },
              data: [
                { value: 1, name: '' },
              ]
            },
            {
              color:[ '#00ABFF', '#00D573','#FFC300', '#00CCFF',"#0B0FF0","#FF6699","#FF9966"],
              type: 'pie',
              radius: ['65%', '80%'],
              labelLine: {
                length:25,
                length2:0,
                maxSurfaceAngle:20
              },
              label: {
                alignTo: 'edge',
                formatter: '{name|{b}}\n{time|{c}%}',
                minMargin: 5,
                edgeDistance: '5%',
                lineHeight: 30,
                rich: {
                  name:{
                    color:"#474E5F", 
                    fontSize: 16,
                  },
                  time: {
                    fontSize: 19,
                    color: 'rgb(44, 221, 225)'
                  }
                }
              },
              itemStyle:{
                borderWidth:7, //设置border的宽度有多大
                borderColor:'#fff',
                borderRadius: 10,
              },
              data:this.listArray
            }
          ]
        }
        this.myChart.setOption(option);
    }  
  },
}
</script>
<style lang="scss" scoped>
.announ {
    background: #FFFFFF;
    border-radius: 10px;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
}
.title {
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #323F51;
    letter-spacing: 0;
    line-height: 18px;
    font-weight: 600;
    margin-bottom: 20px;
}
.block {
    height:362px;
    position: relative;
    padding: 40px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;

}

#mainD{
    width: 100%;
    height: 100%;
}

.block::after {
    content: "";
    position: absolute;
    top: -150%;
    left: -150%;
    width: 400%;
    height: 400%;
    transform: scale(0.25);
    border: 1px solid rgba($color: #E1E1E1, $alpha: 0.7);
    border-radius: 20px;
    pointer-events: none;
}
</style>
